// export const baseURL = "https://ukladmin.3mindsdigital.com";
export const baseURL = "https://admin.uniklinger.com";
export const frontendURL = "https://uklstaging.3mindsdigital.com";